import { isString, isArray, isNumber } from 'lodash-es'

function clearFormData(formData, defaults) {
  const newFormData = {}

  for (let key in formData) {
    if (defaults && defaults.hasOwnProperty(key)) {
      newFormData[key] = defaults[key]
      continue
    }

    const value = formData[key]

    if (isString(value)) {
      newFormData[key] = ''
    }

    if (isArray(value)) {
      newFormData[key] = []
    }

    if (isNumber(value)) {
      newFormData[key] = null
    }
  }

  return newFormData
}

function getAuthHeader() {
  const { token } = JSON.parse(localStorage.getItem('user'))

  return `Bearer ${
    token
  }`
}

function getSupportAttachUrl() {
  let link = '/attachFileToSupportRequest'

  if (process.env.NODE_ENV === 'development') {
    link = '/proxyapi' + link
  } else {
    link = '/base_victory/hs/siteapi' + link
  }
  return link
}

function formatDate(dateString, options) {
  return new Date(dateString).toLocaleDateString('ru-RU', { ...options })
}

function formatNumber(value, type, postfix) {
  if (isNaN(parseFloat(value))) return value

  const options = {
    'currency': { style: 'currency', currency: 'RUB', minimumFractionDigits: 0 },
    'percent': { style: 'percent' },
    'storage': { style: 'decimal' }
  }

  let formatted = new Intl.NumberFormat('ru', options[type] || {}).format(value)

  if (type === 'storage') formatted += ' Гб'

  return formatted + (postfix ? ' ' + postfix : '')
}

export {
  clearFormData,
  getAuthHeader,
  getSupportAttachUrl,
  formatDate,
  formatNumber
}